"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var styles = {
  alertBoxContainer: function alertBoxContainer(_ref) {
    var theme = _ref.theme,
        type = _ref.type,
        bordered = _ref.bordered,
        borderRadius = _ref.borderRadius;
    var alert = theme.components.alert;

    return {
      padding: alert.padding,
      border: bordered && alert[type].border,
      borderRadius: theme.radii[borderRadius],
      backgroundColor: alert[type].backgroundColor,
      color: alert[type].color
    };
  }
};

exports.default = styles;